import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=91a4bc86&scoped=true"
import script from "./CompanySearch.vue?vue&type=script&lang=ts"
export * from "./CompanySearch.vue?vue&type=script&lang=ts"
import style0 from "./CompanySearch.vue?vue&type=style&index=0&id=91a4bc86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a4bc86",
  null
  
)

export default component.exports